export type ViewportBBox = {
  west: number;
  south: number;
  east: number;
  north: number;
};

const MIN_DELTA = 0.001;

const clampLng = (value: number) => Math.max(-180, Math.min(180, value));
const clampLat = (value: number) => Math.max(-90, Math.min(90, value));

export function sanitizeBBox(
  west: number,
  south: number,
  east: number,
  north: number
): ViewportBBox {
  let clampedWest = clampLng(west);
  let clampedEast = clampLng(east);
  let clampedSouth = clampLat(south);
  let clampedNorth = clampLat(north);

  if (clampedEast <= clampedWest) {
    clampedWest = Math.min(clampedWest, 180 - MIN_DELTA);
    clampedEast = Math.min(180, clampedWest + MIN_DELTA);
  }

  if (clampedNorth <= clampedSouth) {
    clampedSouth = Math.min(clampedSouth, 90 - MIN_DELTA);
    clampedNorth = Math.min(90, clampedSouth + MIN_DELTA);
  }

  return {
    west: clampedWest,
    south: clampedSouth,
    east: clampedEast,
    north: clampedNorth,
  };
}
